import {observable, action} from 'mobx';
import questions from '../assets/data/tasks.json';

class Game3Store {

    @observable teamColors = [
        {
            color: "cyan",
            name: "Blue"
        },
        {
            color: "red",
            name: "Red"
        },
        {
            color: "green",
            name: "Green"
        },
        {
            color: "yellow",
            name: "Yellow"
        }];

    @observable numberRounds = 4;
    @observable teamsComposition = [
        {
            teams: 2,
            participants: 6,
        },
        {
            teams: 3,
            participants: 4,
        }
    ];
    @observable numberPlayers = 2;
    @observable extraPoints = false;
    @observable bonusPoints = [
        {
            label: "All tasks finished on time",
            points: 10
        },
        {
            label: "Three tasks finished on time",
            points: 8
        },
        {
            label: "Two tasks finished on time",
            points: 6
        },
        {
            label: "One task finished on time",
            points: 4
        },
        {
            label: "No task done",
            points: 0
        }
    ];
    @observable answers = [
        {
            id: 0,
            name: "Correct task",
            label: "Correct task",
            points: 5,
        },
        {
            id: 1,
            name: "Incomplete task",
            label: "Incomplete task",
            points: 2,
        },
        {
            id: 2,
            name: "Incorrect task",
            label: "Incorrect task",
            points: 0,
        }
    ];
    @observable levels = [];
    @observable questions = []; // All questions
    @observable players = []; // Players Selected with updated scores
    @observable situation = 0;
    @observable winner; // Game's Winner
    @observable loser = []; //Game's Loser;
    @observable round = 1;
    @observable isLoading = false;
    @observable selectedAnswer = -1;
    @observable actualPlayer = null;
    @observable nextTurn = 0;
    @observable lastTurn = false;
    @observable winners = [];
    @observable turn = 0;
    @observable pause = false;
    @observable start = false;
    @observable showGuidelines = false;
    @observable seconds = 1;
    @observable minutes = 10;
    @observable modalIsOpen = false;

    @action
    resetGame() {

        this.levels = [];
        this.questions = [];
        this.round = 1;
        this.selectedAnswer = -1;
        this.actualPlayer = null;
        this.alreadyPlayed = [];
        this.winners = [];
        this.players = [];
    }

    @action
    loadQuestions() {
        this.questions = questions;
        this.levels = Object.keys(questions).map(
            (level, index) => ({id: index, name: level})
        );
    }

    @action
    setPlayers(numberPlayers) {
        let p = [];
        for (let i = 0; i < numberPlayers; i++) {
            const player = {
                name: this.teamColors[i].name + " team",
                team: this.teamColors[i],
                levels: [],
                tasks: [],
                score: 0,
                bonusPoints: 0
            };

            p.push(player);
        }

        // Modify the state only one time
        this.players = p;
        this.numberPlayers = p.length;
    }

    @action
    setSituation(situation) {
        this.situation = situation;
    }

    @action
    changeRound() {
        this.alreadyPlayed = [];
    }

    @action
    setLevelToPlayerAt(player, level, index) {
        // Prevent insert level to index out of bounds
        if (player.levels.length < index) {
            player.levels.length = index;
        }

        player.levels[index] = level;
    }

    @action
    setPlayersTurn() {
        this.nextTurn = 0;
    }

    @action
    getPlayerTurn() {
        let turn = this.nextTurn;

        if( turn === 0 ) {
            this.nextTurn = 1;
            if( this.players.length === 2 ) {
                this.lastTurn = true;
            }
        } else if ( turn === 1 && this.players.length === 3 ) {
            this.nextTurn = 2;
            this.lastTurn = true;
        } else {
            this.nextTurn = 0;
        }

        const player = this.players[turn];
        this.generateRandomQuestionsByLevel(player);

        return this.players[turn];
    }

    @action
    getRandomQuestionByLevel(levels) {
        // Get random level
        let level = levels[Math.floor(Math.random() * levels.length)];

        // TODO: improve this loop removing "N/A" and undefined from levels
        while (level === "N/A" || level === undefined) {
            console.log('repetiu para sempre');
            level = levels[Math.floor(Math.random() * levels.length)];
        }

        // Get random question
        const questionsByLevel = this.questions[level];
        const questionIndex = Math.floor(Math.random() * questionsByLevel.length);
        const question = questionsByLevel[questionIndex];

        // Remove question to NOT REPEAT
        this.questions[level] = [...this.questions[level].filter(q => q !== question)];

        return {statement: question, level};
    }

    @action
    generateRandomQuestionsByLevel(player) {
        let levels = player.levels;
        levels = this.orderLevels(levels);

        // 2 questions to high level
        if( levels.length < 4 ) {
            let ltype = 0;
            for (let i = 0; i < 4; i++) {
                let level = '';
                if ( levels.length === 1 ) {
                    level = levels[0];
                } else if ( levels.length === 2 ) {
                    level = levels[ltype];
                    ltype = ltype === 0 ? 1 : 0;
                } else {
                    if( i === 0 || i === 1) {
                        level = levels[0];
                    }
                    else if ( i === 3) {
                        level = levels[1];
                    } else {
                        level = levels[i];
                    }
                }

                const questionsByLevel = this.questions[level['name']];
                const questionIndex = Math.floor(Math.random() * questionsByLevel.length);
                const question = questionsByLevel[questionIndex];

                this.questions[level['name']] = [...this.questions[level['name']].filter(q => q !== question)];

                let name = level['name'];

                question['hasResponse'] = false;

                player.tasks[i] = {statement: question, name};
            }
        } else {
            for (let i = 0; i < 4; i++) {
                let level = levels[i];
                const questionsByLevel = this.questions[level['name']];
                const questionIndex = Math.floor(Math.random() * questionsByLevel.length);
                const question = questionsByLevel[questionIndex];

                this.questions[level['name']] = [...this.questions[level['name']].filter(q => q !== question)];

                let name = level['name'];

                question['hasResponse'] = false;

                player.tasks[i] = {statement: question, name};
            }
        }
    }

    @action
    orderLevels(levels) {

        let lvs = levels;

        levels = [];

        for (let i = 0; i <= levels.length; i++) {
            switch ( lvs[i] ) {
                case "Basic 1":
                    levels[i] = {'name':lvs[i],'rank': 8};
                    break;
                case "Basic 2":
                    levels[i] = {'name':lvs[i],'rank': 7};
                    break;
                case "Basic 3":
                    levels[i] = {'name':lvs[i],'rank': 6};
                    break;
                case "Intermediate 1":
                    levels[i] = {'name':lvs[i],'rank': 5};
                    break;
                case "Intermediate 2":
                    levels[i] = {'name':lvs[i],'rank': 4};
                    break;
                case "Intermediate 3":
                    levels[i] = {'name':lvs[i],'rank': 3};
                    break;
                case "Advanced 1":
                    levels[i] = {'name':lvs[i],'rank': 2};
                    break;
                case "Advanced 2":
                    levels[i] = {'name':lvs[i],'rank': 1};
                    break;

            }
        }

        levels.sort((a, b) => a.rank - b.rank);
        return levels;
    }
}

export default new Game3Store();


// WEBPACK FOOTER //
// ./src/stores/Game3Store.js